"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DividerTypes = void 0;

var tslib_1 = require("tslib");

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */


var styles = tslib_1.__importStar(require("./Divider.styles"));

exports.DividerTypes = ['LINE_80_10', 'LINE_100_10', 'LINE_100_10_CARD', 'SPACE', 'SPACE_LINE'];

function Divider(_ref) {
  var className = _ref.className,
      type = _ref.type;
  return jsx_runtime_1.jsx("hr", {
    className: className,
    css: styles.wrapper(type)
  }, void 0);
}

exports.default = Divider;